<template>
	<div :class="[editing ? 'editing w-full' : 'shadow-none']">
		<form method="post" :action="'/projects/' + project.id + ''">
			<table class="shadow-none w-full h-full">
		        <tbody>
		            <tr>
		                <td class="text-base font-semibold uppercase">Start Date</td>
		                <td>
		                	<div v-if="! editing">{{ project.start_date }}</div>
			    			<date-picker
			    				v-if="editing"
			    				v-model="project.start_date"
			    				lang="en"
			    				:first-day-of-week="7"
			    				valueType="format"
			    				format="MM/DD/YYYY"
			    				input-name="start_date"
			    				input-class="form-input"
			    				:input-attr="{ size: 10, required: true }"
			    				:clearable="false">
							</date-picker>
		                </td>
		                <td class="text-base font-semibold uppercase">End Date</td>
		                <td>
		                	<div v-if="! editing">{{ project.end_date }}</div>
			    			<date-picker
			    				v-if="editing"
			    				v-model="project.end_date"
			    				lang="en"
			    				:first-day-of-week="7"
			    				valueType="format"
			    				format="MM/DD/YYYY"
			    				input-name="end_date"
			    				input-class="form-input"
			    				:input-attr="{ size: 10, required: true }"
			    				:clearable="false">
							</date-picker>
		                </td>
		                <td class="text-base font-semibold uppercase">Project Type</td>
		                <td>
		                	<div v-if="! editing">{{ project.project_type }}</div>
							<select v-if="editing" v-model="project.project_type" class="form-select" name="project_type" required>
								<option value=""></option>
								<option value="Consolidation">Consolidation</option>
								<option value="Expansion">Expansion</option>
								<option value="New Location">New Location</option>
								<option value="Renewal">Renewal</option>
							</select>
		                </td>                                                                 
		            </tr>
		            <tr>
		                <td class="text-base font-semibold uppercase">Priority</td>
		                <td>
		                	<div v-if="! editing">{{ project.priority }}</div>
							<select v-if="editing" v-model="project.priority" class="form-select" name="priority" required>
								<option value=""></option>
								<option value="Low">Low</option>
								<option value="Medium">Medium</option>
								<option value="High">High</option>
								<option value="Urgent">Urgent</option>
							</select>
		                </td>
		                <td class="text-base font-semibold uppercase">Stage</td>
		                <td>
		                	<div v-if="! editing">{{ project.stage }}</div>
							<select v-if="editing" v-model="project.stage" class="form-select" name="stage" required>
								<option value=""></option>
								<option value="Activated Assignment">Activated Assignment</option>
								<option value="Approval">Approval</option>
								<option value="Build-out">Build-out</option>
								<option value="Comps Research">Comps Research</option>
								<option value="Final Cut">Final Cut</option>
								<option value="Lease Negotation">Lease Negotation</option>
								<option value="Move In">Move In</option>
								<option value="Negotiation">Negotiation</option>
								<option value="RFP Process">RFP Process</option>
								<option value="Sign Off">Sign Off</option>
								<option value="Tour of Comps">Tour of Comps</option>
							</select>
		                </td>
		                <td class="text-base font-semibold uppercase">Status</td>
		                <td>
		                	<div v-if="! editing">{{ project.status }}</div>
							<select v-if="editing" v-model="project.status" class="form-select" name="status" required>
								<option value=""></option>
								<option value="Active">Active</option>
								<option value="Archived">Archived</option>
								<option value="Complete">Complete</option>
								<option value="Holding">Holding</option>
							</select>
		                </td>                 
		            </tr>
		            <tr>
		                <td class="text-base font-semibold uppercase">Property Type</td>
		                <td>
		                	<div v-if="! editing">{{ project.property_type }}</div>
							<select v-if="editing" v-model="project.property_type" class="form-select" name="property_type" required>
								<option value=""></option>
								<option value="Office">Office</option>
								<option value="Industrial">Industrial</option>
								<option value="Flex">Flex</option>
								<option value="Land">Land</option>
								<option value="Retail">Retail</option>
							</select>
		                </td>
		                <td class="text-base font-semibold uppercase">Usage</td>
		                <td>
		                	<div v-if="! editing">{{ project.property_usage }}</div>
							<select v-if="editing" v-model="project.property_usage" class="form-select" name="property_usage" required>
								<option value=""></option>
								<option value="Canadian Ops">Canadian Ops</option>
								<option value="Corporate HQ">Corporate HQ</option>
								<option value="Digital Retailing">Digital Retailing</option>
								<option value="DMS">DMS</option>
								<option value="Inventory/Interactive">Inventory/Interactive</option>
								<option value="Operations">Operations</option>
								<option value="Production">Production</option>
								<option value="RTS">RTS</option>
								<option value="Sales &amp; F&amp;I">Sales &amp; F&amp;I</option>
								<option value="Sales RTS">Sales RTS</option>
								<option value="Sublet">Sublet</option>
								<option value="Technology RTS">Technology RTS</option>
								<option value="Vacant">Vacant</option>
							</select>
		                </td>
		                <td class="text-base font-semibold uppercase">Region</td>
		                <td>
		                	<div v-if="! editing">{{ project.property_region }}</div>
							<select v-if="editing" v-model="project.property_region" class="form-select" name="property_region" required>
								<option value=""></option>
								<option value="Central">Central</option>
								<option value="Mid-Atlantic">Mid-Atlantic</option>
								<option value="Northeast">Northeast</option>
								<option value="Northwest">Northwest</option>
								<option value="Outside USA">Outside USA</option>
								<option value="Southeast">Southeast</option>
								<option value="Southwest">Southwest</option>
							</select>
		                </td>
		            </tr>
		            <tr>
		                <td class="text-base font-semibold uppercase">Required Sq Ft</td>
		                <td>
		                	<div v-if="! editing">{{ project.required_sq_ft | number }}</div>
		                	<number-input v-if="editing" v-model="project.required_sq_ft" name="required_sq_ft"></number-input>
		                </td>
		                <td></td>
		                <td></td>
		                <td></td>
		                <td></td>
		            </tr>
		        </tbody>
		    </table>
		    <div class="w-full my-6 leading-normal">
		    	<div v-if="! editing" v-html="$options.filters.nl2br(project.description)"></div>
		    	<textarea v-if="editing" v-model="project.description" name="description" class="form-textarea w-full" rows="5"></textarea>
		    </div>
	        <div v-if="editing" class="text-right">
	            <div class="flex items-center justify-end p-2">
	                <button @click.prevent="$parent.editing = ! $parent.editing" class="btn btn-secondary ml-6 mr-3">Cancel</button>
	                <button type="submit" class="btn btn-green">Save</button>
	            </div>
	        </div>
	        <input type="hidden" name="client_id" :value="this.clientId">
	        <input type="hidden" name="name" :value="project.name">
	        <input type="hidden" name="_method" value="PATCH">
	        <input type="hidden" name="_token" :value="csrf">
    	</form>
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				type: [Array, Object],
				required: true
			},
			clientId: {
				type: Number,
				required: true
			}
		},

		data() {
			return {
				'project': this.data,
				csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			}
		},

		computed: {
			editing() {
				return this.$parent.editing;
			}
		},

		methods: {
			saveProject() {
				alert('test');
			}
		},
	}
</script>